import { render, staticRenderFns } from "./AssetResourceView.vue?vue&type=template&id=f1b96236&scoped=true"
import script from "./AssetResourceView.vue?vue&type=script&lang=js"
export * from "./AssetResourceView.vue?vue&type=script&lang=js"
import style0 from "./AssetResourceView.vue?vue&type=style&index=0&id=f1b96236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b96236",
  null
  
)

export default component.exports